import type { StageConfig } from '@capture/shared';
import { MinimumRoleSelect } from './MinimumRoleSelect';
import { StageDeepLinks } from './StageDeepLinks';

export function QaPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const minimumRole = (config.config.minimumRole as string) ?? 'qa';
  return (
    <div className="stage-panel">
      <p className="stage-panel__hint" data-testid="qc-sampling-note">
        QC sampling — the % of documents held for review (and any per-operator overrides) — is
        configured on this step&apos;s <strong>Routing Condition</strong>, which lives on the{' '}
        <strong>Job Config</strong> page&apos;s <strong>Workflow tab</strong> (not in Form Config):
        add a &ldquo;Hold % for QC&rdquo; (<code>qc_sample</code>) condition to hold a sample and
        auto-advance the rest. (Leaving no condition holds every document.)
      </p>
      <label>
        Minimum role
        <MinimumRoleSelect value={minimumRole} onChange={(v) => onChange({ ...config, config: { ...config.config, minimumRole: v } })} />
      </label>
      <StageDeepLinks stage="qa" />
    </div>
  );
}
